import { render } from "./list.vue?vue&type=template&id=680ba76c&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=680ba76c&lang=scss&scoped=true"
import "./list.vue?vue&type=style&index=1&id=680ba76c&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680ba76c"]])

export default __exports__